import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../../redux/hooks';
import { useTranslation } from 'react-i18next';
import useMediaQuery from '@mui/material/useMediaQuery';

// Components 

import Box from '@mui/material/Box';
import Info from './info/Info';

const Start: React.FC = () => {

    const dispatch = useAppDispatch(); 
    const { t } = useTranslation();

    const isMobile = useMediaQuery('(max-width: 600px)');

    const colors = useAppSelector(state => state.theme.colors);

    return (

        <Box sx={{ 
            display: 'flex', 
            flexDirection: 'column',
            alignItems: 'center', 
            width: '90%', // Take full width of parent
            // maxWidth: '1400px', // Max width to prevent becoming too wide on large screens
            height: 'auto', // Adjust height based on content
            borderRadius: 3, // Slightly smaller radius
            backgroundColor: colors?.container,
            overflowY: 'auto', // Allow scroll if content overflows vertically
            overflowX: 'hidden',
            padding: isMobile ? 2 : 4, // Add padding, more on desktop
            margin: 'auto', // Center the component on the page
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)', // Softer shadow
            boxSizing: 'border-box',
        }}>

            <Info /> 

        </Box>

    );

};

export default Start;